import axios from "axios";

const state = () => ({
  users: [],
 
});
const getters = {
  usersState(state) {
    return state.users;
  },
 
};
const mutations = {
  getUserLoad(state, payload) {
    state.users = payload;
  },
  
};
const actions = {
  getUsers(context) {
    return axios
      .get(process.env.VUE_APP_BASE_URL+"usuarios")
      .then((data) => {
        context.commit("getUserLoad", data.data);
      });
  },
 
};
export default {
  state,
  getters,
  actions,
  mutations,
};
